import { Navigate } from 'react-router-dom';

/**
 * Guard component that redirects blocked routes to /app/work-orders
 */
export default function RouteGuard() {
  return <Navigate to="/app/work-orders" replace />;
}

